import React, {Component} from 'react';
import {connect} from 'react-redux';
import {generateFileName} from './helpers';
import {createCsvContent, downloadCsvFile} from 'services/csv/creator';
import CsvDataCreator from './services/csv-data-creator';
import AttributesMapFactory from 'components/organisms/players-csv/attributes-map-factory';

class DownloadPlayersCsvButton extends Component {
    onClick() {
        const {players, sportConfig} = this.props;

        const attributes = AttributesMapFactory.fromSportConfig(sportConfig);

        const csvDataCreator = new CsvDataCreator(attributes);
        const csvData = csvDataCreator.createCsvData(players.getAllAsArr());

        const csvFile = createCsvContent(csvData);

        downloadCsvFile(csvFile, generateFileName());
    }

    canComponentBeRendered() {
        const {players} = this.props;

        return players.isPlayersGroupReady();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        return (
            <button
                type="button"
                data-tooltip-html="Download user projections"
                onClick={this.onClick.bind(this)}
                className="btn-text"
            >
                <i className="fa fa-download" /> Download csv
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig} = state;

    return {
        sportConfig,
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(DownloadPlayersCsvButton);
